import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as Action from "../../../applicant/_redux/applicantActions";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import { TextArea } from "../../../../../_metronic/_partials/controls/forms/TextArea";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import { swalError, swalSuccess } from "../../../../helpers/swal";
import * as EmployeeListAction from "../../../employee/_redux/employeeActions";
import { Checkbox } from "antd";

const _init = {
  per_address_line_1: "",
  per_international_address: "",
  per_divisions_id: "",
  per_districts_id: "",
  per_thana_id: "",
  per_postal_code: "",
  is_same_as_permanent_address: "",
};

const PermanentAddress = ({ id }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(_init);

  const { division, per_district, per_thana, employeeProfile } = useSelector(
    ({ applicant, employeeList }) => ({
      division: applicant.division,
      per_district: applicant.per_district,
      per_thana: applicant.per_thana,
      employeeProfile: applicant.personal_info,
    }),
    shallowEqual
  );

  const validationSchema = Yup.object().shape({
    per_address_line_1: Yup.string().required("Full address is required"),
    per_divisions_id: Yup.string().nullable(),
    per_districts_id: Yup.string().nullable(),
    per_thana_id: Yup.string().nullable(),
  });

  const handleSaveProfile = async (values) => {
    try {
      values.is_same_as_permanent_address = isChecked ? 1 : 0;

      values.per_address_line_1 = values?.per_address_line_1;
      values.per_divisions_id =
        values?.per_divisions_id === "" ? null : values?.per_divisions_id;
      values.per_districts_id =
        values?.per_districts_id === "" ? null : values?.per_districts_id;
      values.per_thana_id =
        values?.per_thana_id === "" ? null : values?.per_thana_id;
      values.per_international_address = values?.pre_international_address;

      if (id && values) {
        setLoading(true);

        const res = await API.patch(`/hrms_applicant/${id}`, values);

        if (res.data.success) {
          dispatch(
            Action.createProfileScore(
              {
                name: ["Permanent Address"],
                applicant_id: id,
              },
              () => {
                dispatch(Action.getApplicantPersonalInfo(id));
              }
            )
          );
          // dispatch(Action.getApplicantPersonalInfo(id));

          swalSuccess("Permanent Address Updated Successfully!!");
        } else {
          swalError("Something went wrong");
        }
      }
    } catch (error) {
      console.error(error);
      swalError("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(Action.getAllDivision());
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(Action.getApplicantPersonalInfo(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (employeeProfile && Object.keys(employeeProfile).length > 0) {
      if (employeeProfile.per_divisions_id) {
        dispatch(
          Action.getAllPerDistrictByDivision(employeeProfile.per_divisions_id)
        );
      }
      if (
        employeeProfile.per_divisions_id &&
        employeeProfile.per_districts_id
      ) {
        dispatch(
          Action.getAllPerThanaDistrictByDivision(
            employeeProfile.per_divisions_id,
            employeeProfile.per_districts_id
          )
        );
      }

      setProfile({
        per_address_line_1: employeeProfile.per_address_line_1 ?? "",
        per_international_address:
          employeeProfile.per_international_address ?? "",
        per_address_line_2: employeeProfile.per_address_line_2 ?? "",
        per_divisions_id: employeeProfile.per_divisions_id ?? "",
        per_districts_id: employeeProfile.per_districts_id ?? "",
        per_thana_id: employeeProfile.per_thana_id ?? "",
        per_postal_code: employeeProfile.per_postal_code ?? "",
        is_same_as_permanent_address:
          employeeProfile.is_same_as_permanent_address == null
            ? "false"
            : employeeProfile.is_same_as_permanent_address,
      });

      setIsChecked(
        employeeProfile?.is_same_as_permanent_address ? true : false
      );
    } else {
      setProfile(_init);
    }
  }, [employeeProfile]);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckSameAddress = (val, values, setFieldValue) => {
    setIsChecked(!isChecked);
    if (val) {
      setFieldValue("per_address_line_1", employeeProfile.pre_address_line_1);
      setFieldValue("per_districts_id", employeeProfile.pre_districts_id);
      setFieldValue("per_divisions_id", employeeProfile.pre_divisions_id);
      setFieldValue("per_thana_id", employeeProfile?.pre_hrms_thana?.id);
      setFieldValue("per_postal_code", employeeProfile?.pre_postal_code);
      setFieldValue(
        "per_international_address",
        employeeProfile?.pre_international_address
      );

      dispatch(
        Action.getAllPreDistrictByDivision(employeeProfile.pre_divisions_id)
      );
      dispatch(
        Action.getAllPreThanaDistrictByDivision(
          employeeProfile.pre_divisions_id,
          employeeProfile.pre_districts_id
        )
      );
    } else {
      setFieldValue("per_address_line_1", "");
      setFieldValue("per_districts_id", "");
      setFieldValue("per_divisions_id", null);
      setFieldValue("per_thana_id", "");
      setFieldValue("per_postal_code", "");
      setFieldValue("per_international_address", "");
    }
  };

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={profile}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSaveProfile(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Permanent Address(as per NID/Passport)</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mb-5">
                <Field
                  type="checkbox"
                  checked={isChecked}
                  id="sameAddress"
                  onChange={(e) =>
                    handleCheckSameAddress(
                      e.target.checked,
                      values,
                      setFieldValue
                    )
                  }
                />
                <label className="form-check-label ml-2" htmlFor="sameAddress">
                  Same as Present Address{" "}
                </label>
              </div>
              <div className="col-md-12 mb-4">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <Input
                          label={"Full Address"}
                          value={values.per_address_line_1}
                          isRequired
                          onChange={(e) => {
                            setFieldValue("per_address_line_1", e.target.value);
                          }}
                        />
                        <Checkbox
                          checked={values.per_international_address === "true"}
                          onChange={(e) => {
                            setFieldValue(
                              "per_international_address",
                              e.target.checked?.toString()
                            );
                          }}
                        >
                          International Address
                        </Checkbox>
                        {errors.per_address_line_1 &&
                          touched.per_address_line_1 && (
                            <div className="text-danger">
                              {errors.per_address_line_1}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 mb-4">
                        <SelectInput
                          label={"Division"}
                          options={division}
                          value={values.per_divisions_id}
                          onChange={(value) => {
                            setFieldValue("per_divisions_id", value);
                            dispatch(Action.getAllPerDistrictByDivision(value));
                          }}
                        />
                        {errors.per_divisions_id &&
                          touched.per_divisions_id && (
                            <div className="text-danger">
                              {errors.per_divisions_id}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 mb-4">
                        <SelectInput
                          label={"District"}
                          options={per_district}
                          value={values.per_districts_id}
                          onChange={(value) => {
                            setFieldValue("per_districts_id", value);
                            dispatch(
                              Action.getAllPerThanaDistrictByDivision(
                                values.per_divisions_id,
                                value
                              )
                            );
                            setFieldValue("per_thana_id", "");
                          }}
                        />
                        {errors.per_districts_id &&
                          touched.per_districts_id && (
                            <div className="text-danger">
                              {errors.per_districts_id}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 mb-4">
                        <SelectInput
                          label={"Thana/ Upazila"}
                          options={per_thana}
                          value={values.per_thana_id}
                          onChange={(value) => {
                            setFieldValue("per_thana_id", value);
                          }}
                        />
                        {errors.per_thana_id && touched.per_thana_id && (
                          <div className="text-danger">
                            {errors.per_thana_id}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-4">
                        <label>
                          Postal Code{" "}
                          <span className="text-muted">(optional)</span>
                        </label>
                        <input
                          placeholder="Enter Postal Code"
                          type="text"
                          name="per_postal_code"
                          value={values.per_postal_code}
                          className="form-control"
                          onChange={(e) => {
                            setFieldValue("per_postal_code", e.target.value);
                          }}
                        />
                        {errors.per_postal_code && touched.per_postal_code && (
                          <div className="text-danger">
                            {errors.per_postal_code}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              {/* <button className='btn btn-default mr-4' >Cancel</button> */}
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PermanentAddress;
